const initTextGalleryAccordionBlockWidget = () => {
    const flickitySlidersArray = initCarousel("[data-gallery-carousel] [data-slider]", cellAlign.center, true, false, true, false, true);
    flickitySlidersArray && flickitySlidersArray.forEach(flickitySlider => {
        //show current slide index
        const currentSlideIndex = flickitySlider.slider.closest("[data-gallery-carousel]").querySelector("[data-current-slide-index]");
        flickitySlider.on("change", () => {
            currentSlideIndex.innerHTML = (flickitySlider.selectedIndex + 1).toString();
        });
        //custom binding to buttons
        const prevButton = flickitySlider.slider.closest("[data-gallery-carousel]").querySelector("[data-prev-button]");
        //custom binding to prev button
        prevButton.addEventListener("click", () => {
            flickitySlider.previous();
        });
        //custom binding to next button
        const nextButton = flickitySlider.slider.closest("[data-gallery-carousel]").querySelector("[data-next-button]");
        nextButton.addEventListener("click", () => {
            flickitySlider.next();
        });
    });
};
